/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CLOSE: 'Cerrar',
    CONFIRM: 'Confirmar',
    CONFIRM_AND_NEXT: 'Confirmar y siguiente',
    CONFIRM_AND_SAVE: 'Confirmar y guardar',
    CREATE: 'Crear',
    DELETE: 'Eliminar',
    EDIT: 'Editar',
    NEW_POST: 'Nueva publicación',
    OK: 'Ok',
    REJECTED: 'Rechazada',
    REPLY: 'Responder',
    SAVE: 'Guardar',
    SEND: 'Enviar',
    SKIP_CROP: 'Omitir recorte',
    UPDATE: 'Actualizar',
    UPGRADE: 'Unirse al club'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: '¡fallo al copiar al portapapeles!',
    INSTAGRAM_PUBLISHING_ERROR:
      'Ocurrió un error al compartir la publicación en Instagram.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Ocurrió un error al compartir la publicación en Instagram. ¿Desea continuar con la publicación?',
    LINK_ALREADY_EXISTS: 'El enlace ya existe',
    LINK_VALIDATION_FAILED: 'No se pudo validar el enlace',
    MANDATORY_FIELD: 'Campo obligatorio',
    MAXIMUM_CHARACTERS: 'Se alcanzó el máximo de caracteres',
    MAXIMUM_FILE_SIZE: '¡El tamaño máximo permitido es de 100MB!',
    MINIMUM_DIMENSIONS:
      'El archivo cargado debe tener dimensiones mínimas de 480×960',
    PAGE_NOT_APPROVED:
      '❌ Lamentablemente, no fue posible aprobar tu página esta vez. ¡Pero no te preocupes! ✨\n Puedes editar tu perfil y corregir los campos indicados para volver a enviarlo para aprobación.',
    REACTION_LIKE: '¡Ocurrió un error, por favor intente más tarde!',
    UNSUPPORTED_FORMAT: '¡Formato no compatible!',
    VIDEO_CROP: '¡Falló el recorte del video!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'Acepto los términos y condiciones',
    ADDITIONAL_INFORMATION: 'Información adicional',
    ADDRESS: 'Dirección',
    APPROVED: 'publicado',
    ASSETS: 'Imágenes o videos (tamaño máximo 100MB)',
    ASSOCIATE_PRODUCT: 'Asociar producto de Prozis',
    ASSOCIATED_PRODUCTS: 'Productos de Prozis asociados',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Subtítulo',
    CHART_BY: 'Gráfico por',
    COMMENTS: 'Comentarios',
    COMMISSION: 'comisión',
    COMMISSIONS: 'comisiones',
    COMMISSIONS_LAST_30_DAYS: 'últimos 30 días',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Dirección completa sin número de casa',
    CONTINUE_WITH_INSTAGRAM: 'Continuar con Instagram',
    COUNTRY: 'Dirección solo con país',
    CREATE_PROFILE: 'Crear perfil',
    CROPPING_ASSET: 'Recortar {asset} {ratio}',
    DELETE_POST: '¿Eliminar publicación?',
    DELETE_POST_ARE_YOU_SURE:
      '¿Está seguro de que desea eliminar la publicación?',
    DESCRIPTION: 'Biografía',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Descargar',
    DRAFT_PROFILE: 'Borrador',
    EDIT_PROFILE: 'Editar página',
    ENGAGEMENT: 'Interacción',
    ERROR: 'Error',
    FEED: 'feed',
    FOLLOWERS: 'Seguidores',
    FRIDAY: 'Friday',
    GALLERY: 'Galería',
    HIDDEN: 'No muestra dirección',
    IMAGE: 'imagen',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Cuenta de Instagram',
    LATEST_FIRST: 'Más recientes primero',
    LEAST_PROFITABLE: 'Menos rentables primero',
    LIKES: 'Me gusta',
    LIKES_DELETED: 'Me gusta eliminados',
    LINK: 'Enlace',
    LIVE: 'Directo',
    LIVES: 'Directos',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Dirección solo con ciudad y país',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Dirección completa',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Dirección completa sin el número de puerta',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Dirección solo con el país',
    MONDAY: 'Monday',
    MORE: '... Ver más',
    MOST_PROFITABLE: 'Más rentables primero',
    NAME: 'Nombre',
    NEW_FOLLOWERS: 'Nuevos seguidores',
    NEW_POST: 'Nueva publicación',
    NO_PRODUCTS_FOUND: 'No se encontró ningún producto.',
    NUMBER_OF_FILES: '{file} de {files}',
    OLDEST_FIRST: 'Más antiguas primero',
    ORIGINAL: 'Original',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Fotos de página',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} d',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'pendiente',
    POST: 'Publicación',
    POST_COMMENTS: 'Comentarios de la publicación',
    POST_PRODUCTS: 'Productos de la publicación',
    POST_VIEWS: 'Vistas de publicaciones',
    POSTING_ON_INSTAGRAM: 'Publicando en Instagram',
    POSTS: 'Publicaciones',
    PRODUCTS_HASHTAGS: 'Etiquetas de productos',
    PRODUCTS_LINKS: 'Enlaces de productos',
    PROFESSIONAL_PAGE: 'Página Profesional',
    PROFILE: 'Perfil',
    PROFILE_PHOTO: 'Foto de perfil',
    PROFILE_STATUS: 'Estado del perfil',
    PROFILE_VIEWS: 'Vistas del perfil',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Comunidad Prozis',
    QUESTION: 'Pregunta',
    QUESTION_REPLY: 'Responder a la pregunta',
    QUESTIONS: 'Preguntas',
    REELS: 'reels',
    REJECTED: 'no publicado',
    REJECTED_PROFILE: 'Rechazado',
    REJECTION_REASON: 'Motivo del rechazo',
    REPLY: 'Responder',
    REQUIRED_FIELDS: 'Campos obligatorios',
    RESET: 'Limpiar',
    SATURDAY: 'Saturday',
    SEARCH: 'Buscar',
    SEARCH_AT_LEAST:
      '¡La palabra de búsqueda debe tener al menos 3 caracteres!',
    SEE_LESS: 'Esconder',
    SEE_MORE: 'Ver más',
    SEE_ORIGINAL: 'Ver original',
    SEE_TRANSLATION: 'Ver traducción',
    SHARE_ON_INSTAGRAM: 'Compartir en Instagram',
    SHARE_PROFILE: 'Compartir página',
    SOCIAL_NETWORK: 'Red social',
    SOCIAL_NETWORK_COMMISSIONS: 'Comisiones de la red social',
    SOCIAL_NETWORK_PAGE: 'Página Social',
    SOUND: 'Sonido',
    SPECIALTIES: 'Especialidades',
    STATISTICS_POST: 'Estadísticas de la publicación',
    STATISTICS_PROFILE: 'Estadísticas del perfil',
    STATS_POST_TOTAL: 'Total de comisiones de la publicación',
    STATS_POST_TOTAL_COMMENTS: 'Comentarios/preguntas de la publicación',
    STATS_POST_TOTAL_LIKES: 'Me gusta obtenidos en la publicación',
    STATS_POST_TOTAL_PRODUCTS: 'Productos asociados a la publicación',
    STATS_POST_TOTAL_QUESTIONS: 'Preguntas respondidas en la publicación',
    STATS_POST_TOTAL_VALUE: 'Valor por la publicación',
    STATS_PROFILE_TOTAL: 'Total de comisiones en publicaciones',
    STATS_PROFILE_TOTAL_COMMENTS: 'Comentarios/preguntas en publicaciones',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Nuevos seguidores obtenidos',
    STATS_PROFILE_TOTAL_LIKES: 'Me gusta obtenidos en publicaciones',
    STATS_PROFILE_TOTAL_POSTS: 'Valor obtenido en publicaciones',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Productos asociados de publicaciones',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Preguntas respondidas en publicaciones',
    STORY: 'story',
    SUCCESS: 'Éxito',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Términos y condiciones',
    THURSDAY: 'Thursday',
    TITLE: 'Título',
    TOTAL_VIEWS: 'Total de vistas',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'No seguidores',
    UNREAD: 'Por leer',
    UPDATE_POST: 'Actualizar publicación',
    UPDATED: 'Actualizado el {date}',
    UPLOAD: 'Cargar archivo',
    UPLOADING_FILES: 'Cargando archivo(s)',
    USER_NAME: 'Nombre de usuario',
    VIDEO: 'vídeo',
    VIEW_ALL_COMMENTS: 'Ver los {total} comentarios',
    VIEW_MORE: 'Ver más',
    VIEWS: 'Vistas',
    VISIBILITY_LEVEL: 'Nivel de visibilidad',
    WAITING_APPROVAL: 'Esperando aprobación',
    WARNING: 'Aviso',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Tu perfil'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Aún no hay preguntas.',
    TERMS_AND_CONDITIONS:
      'Al interactuar con la \'Red Social\' de Prozis (por ejemplo, comentando y/o compartiendo contenido y reacciones directamente), el Usuario declara que ha leído, entendido y aceptado los siguientes Términos y Condiciones (T&C).\n\nProzis se reserva el derecho de actualizar los Términos y Condiciones en cualquier momento, sin previo aviso. Prozis tendrá el derecho de ejercer todos los recursos legales disponibles.\n\nAl acceder a la \'Red Social\', el Usuario declara tener al menos 18 años y asume toda la responsabilidad por publicaciones, comentarios, imágenes y videos enviados (\'Contenido\') en la propia \'Red Social\'.\n\nEl Contenido debe pertenecer al Usuario, quien declara ser el autor y poseer todos los derechos de propiedad intelectual. El Contenido no debe representar ninguna situación, edificio u objeto particular y/o protegido por derechos de autor, marca registrada, o en general, marcas y logotipos de otras empresas, a menos que el Usuario haya obtenido el consentimiento necesario para su uso.\n\nEl Contenido no debe incluir a ninguna otra persona que no sea el Usuario, a menos que se haya obtenido su consentimiento por escrito, lo cual es responsabilidad del Usuario. El Usuario indemnizará y mantendrá a Prozis libre de daños por el uso de tales imágenes y/o videos.\n\nUna vez compartido, el Contenido será propiedad exclusiva de Prozis, quien estará autorizada a publicar y/o distribuir y/o utilizar y/o reproducir y/o comunicar y/o modificar, por cualquier medio técnico y de cualquier forma, el Contenido mencionado, sin exclusión, sin plazos y sin derecho a ninguna compensación para los sujetos involucrados.\n\nDespués de una posible carga de contenido, Prozis se reserva el derecho de dejar visible solo el material que, a su exclusivo juicio, no perjudique la imagen de otros, así como que no sea ofensivo para la moral actual o que sea perjudicial para los derechos de los demás; tendencioso, difamatorio, obsceno, vulgar, calumnioso, racista o que constituya una forma de publicidad de cualquier actividad comercial no relacionada con el tema propuesto o que tenga como objetivo promover cualquier marca, producto o servicio diferente al de la \'Red Social\', con Contenido no original del Usuario, es decir, copiado de otras fuentes, o contenido en violación del sistema legal español, contrariando la decencia pública, las regulaciones de privacidad y, en general, la legislación vigente.\n\nProzis también se reserva el derecho de eliminar, antes o después de la publicación, cualquier comentario que, a su exclusivo criterio, pueda ser ofensivo, inapropiado y/o inconsistente con el espíritu de la \'Red Social\'.\n\nProzis también se reserva el derecho de, en cualquier momento, eliminar comentarios y/o contenido publicado en su \'Red Social\', independientemente o a pedido de terceros, así como Autoridades Judiciales, en caso de disputas relacionadas con la legalidad o legitimidad de dicha publicación o comentario. Solo si el Contenido es considerado adecuado por la moderación de la \'Red Social\' será dejado visible.\n\nDespués de la carga de un Contenido en la \'Red Social\', Prozis se reserva el derecho de cargar o compartir nuevamente, directamente, el Contenido del Usuario en sus plataformas digitales para promover su marca.',
    WITHOUT_POSTS: 'Aún no hay publicaciones.',
    WITHOUT_POSTS_STATISTICS:
      'No hay publicaciones entre las fechas seleccionadas.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: '¡Enlace copiado con éxito al portapapeles!',
    CREATED_SUCCESSFULLY: '¡Creado con éxito!',
    ERROR_PUBLISHING_INSAGRAM: 'La publicación se ha compartido en Instagram.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'La publicación se ha compartido con éxito en Instagram.',
    POST_CREATED_SUCCESSFULLY: '¡Creada con éxito!',
    POST_SAVED_SUCCESSFULLY: '¡Actualizada con éxito!',
    POST_SUCCESSFULLY_DELETED: 'Eliminada con éxito.',
    SAVED_SUCCESSFULLY: '¡Actualizado con éxito!',
    SUCCESSFULLY_DELETED: 'Eliminado con éxito.',
    SUCCESSFULLY_REPLIED: 'Respondida con éxito.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS:
      '¡Por favor acepte los términos y condiciones!',
    EMPTY_PROFILE_IMAGE: '¡Debe subir una imagen de perfil!',
    INVALID_FORM: '¡Formulario inválido!'
  }
};
